import vars from '../helpers';

let $cardCheck = $('.card__check');

$cardCheck.on('click', (e) => {
	let $current = $(e.currentTarget);

	if (!$current.hasClass('is-active')) {
		$current.addClass('is-active');
	}
});